(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sectionai-category-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const categoryNavSection = document.querySelector('.sai-category-nav-{{ section_id }}');
  if (!categoryNavSection) return;
  
  // Handle section load event for Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === '{{ section_id }}') {
      // Re-initialize any needed functionality here if required
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
